const media = {
  mobile: "@media screen and (max-width: 470px)",
  tablet: "@media screen and (min-width: 470px) and (max-width: 1023px)",
  desktop: "@media screen and (min-width: 1023px)",
};

export default media;